/* Sticky koopbalk op mobiel: verschijnt zodra de hoofd-koopknop uit beeld scrolt.
   De knop activeert de echte add-to-cart (Dawn <product-form>). Op desktop nooit zichtbaar. */
(function () {
  var bar = document.querySelector('[data-sk-sticky-atc]');
  if (!bar) return;

  var atc = document.querySelector('.product-form__submit');
  if (!atc) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var trigger = bar.querySelector('[data-sk-sticky-trigger]');
  var priceEl = bar.querySelector('[data-sk-sticky-price]');
  var atcVisible = true;

  function update() {
    bar.hidden = !(mq.matches && !atcVisible);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        atcVisible = entries[0].isIntersecting;
        update();
      },
      { rootMargin: '0px 0px -40px 0px' }
    ).observe(atc);
  }

  if (trigger) {
    trigger.addEventListener('click', function () {
      atc.click();
    });
  }

  // Prijs in de balk gelijkhouden met de hoofdprijs (bij variantwissel).
  function syncPrice() {
    if (!priceEl) return;
    var main = document.querySelector('[id^="price-"]');
    if (!main) return;
    var p =
      main.querySelector('.price-item--sale') ||
      main.querySelector('.price-item--regular') ||
      main.querySelector('.price-item');
    if (p && p.textContent.trim()) priceEl.textContent = p.textContent.trim();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, product-form')) {
      setTimeout(syncPrice, 350);
    }
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', update);
  } else if (mq.addListener) {
    mq.addListener(update);
  }
  update();
})();
